import type { LoadedRefinePage } from "../../hooks/useRefinePage";
import { CollapsibleDrawer } from "../CollapsibleDrawer";
import { ParameterPanel } from "../ParameterPanel";

const EXPANDED_WIDTH = "w-[clamp(20rem,30vw,455px)]";

/** Collapsible parameter drawer (see ``CollapsibleDrawer``). */
export function RefineDrawer({ page }: { page: LoadedRefinePage }) {
  return (
    <CollapsibleDrawer
      isCollapsed={page.isDrawerCollapsed}
      onCollapsedChange={page.setIsDrawerCollapsed}
      panel="refine panel"
      expandedWidth={EXPANDED_WIDTH}
      className="h-full"
      railClassName="flex shrink-0 items-center justify-center px-6 py-6"
    >
      {(collapseToggle) => (
        <ParameterPanel
          imageId={page.image.id}
          shouldAutoExtract={page.shouldAutoExtract}
          onExtractionStateChange={page.setIsExtractingParameters}
          collapseToggle={collapseToggle}
          panel={{
            formParameterGroups: page.parameter_groups || [],
            originalParameterGroups: page.image.parameter_groups ?? undefined,
            isParametersDirty: page.isParametersDirty,
            promptDirty: page.promptDirty,
            hasReferenceImages: page.referenceImages.length > 0,
            processing: {
              isRegenerating: page.isRegenerating,
              isInitialLoading: page.isLoading,
              isAttachingImage: page.isAttachingImage,
            },
            onParameterChange: page.handleParameterChange,
            onRegenerateImages: page.handleRegenerateImages,
            projectId: page.image.project_id,
            isResyncingParameters: page.isResyncingParameters,
          }}
        />
      )}
    </CollapsibleDrawer>
  );
}
